// import { clone } from 'lodash-es';
// import { default as Button } from 'ant-design-vue/lib/button';
import { transformBlobToFile, TargetEnum, DownloadTypeEnum } from './config';
import Request from '../../request';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';

export default {
  name: 'FcDownload',
  props: {
    type: {
      type: String,
      validator(value) {
        return Object.values(DownloadTypeEnum).includes(value);
      },
      default: () => {
        return DownloadTypeEnum.LINK;
      },
    },
    action: {
      // 下载地址/请求地址
      type: String,
      default: () => {
        return '';
      },
    },
    method: {
      // 请求方法
      type: String,
      default: () => {
        return 'post';
      },
    },
    data: {
      // 请求参数
      type: [Object, Array],
      default: () => {
        return undefined;
      },
    },
    target: {
      // 请求方法
      type: String,
      validator(value) {
        return Object.values(TargetEnum).includes(value);
      },
      default: () => {
        return TargetEnum.SELF;
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    clickDownload() {
      const { type, action, method, data } = this;

      // 1.直接打开文件下载链接
      if (type === DownloadTypeEnum.LINK) {
        this.handleFileLink(action);
      }

      // 2.接口请求-文件流
      if (type === DownloadTypeEnum.BLOB) {
        this.handleFileBlob(action, method, data);
      }

      // 3.接口请求-获取文件相关信息（如token、下载链接等）
      if (type === DownloadTypeEnum.INFO) {
        this.handleFileInfo({ action, method, data }, response => {
          this.$emit('afterDownload', response);
        });
      }
    },

    /**
     * 直接打开下载链接
     * @param {*} url 下载链接
     */
    handleFileLink(url) {
      const { target } = this;
      const { locale } = this.configProvider;
      if (!url) {
        this.$message.warning(`${locale.Download.error}:${locale.Download.messageLink}!`);
        return;
      }
      window.open(url, target);
    },

    /**
     * 通过请求获取文件流
     * @param {*} param 请求相关参数
     * @param {*} callback 回调
     */
    async handleFileBlob(action, method, data) {
      const { locale } = this.configProvider;
      if (!action) {
        this.$message.warning(`${locale.Download.error}:${locale.Download.messageRequest}!`);
        return;
      }
      const headers = { responseType: 'blob' };
      Request[method](action, data, { headers })
        .then(response => {
          const { code, message } = response.data;
          if (+code === 999) {
            this.$notification.warning({
              message: locale.Download.success,
              description: message,
            });
            return;
          }
          // 处理工作流
          transformBlobToFile(response);
        })
        .catch(err => {
          console.log(locale.Download.error, err);
        });
    },

    /**
     * 通过请求获取返回值——操作下载
     * @param {*} param 请求相关参数
     * @param {*} callback 回调
     */
    async handleFileInfo({ action, method, data }, callback) {
      const { locale } = this.configProvider;
      if (!action) {
        this.$message.warning(`${locale.Download.error}:${locale.Download.messageRequest}!`);
        return;
      }
      Request[method](action, data)
        .then(response => {
          // 组件抛出接口请求返回，使用者根据实际情况自行处理
          callback && callback(response);
        })
        .catch(err => {
          console.log(locale.Download.error, err);
        });
    },
  },

  render() {
    const { $slots } = this;
    return (
      <div class={`fc-download`} onClick={this.clickDownload}>
        {$slots.default}
      </div>
    );
  },
};
